// V1
import { useQuery } from "@apollo/client";
import { EVENT_AWARD_TYPES } from "../../../api/event";
import Card from "../../Card";
import "./EventAwards.css";
import Avatar from "../../Avatar";
import captureException from "../../../utils/captureException";
import { Link } from "react-router-dom";

function EventAwardType({ awardType, canManageEvent }) {
  const profile = awardType?.placements?.[0]?.profile;

  if (!profile && !canManageEvent) {
    return <div />;
  }

  return (
    <div className="fixture-awards-card__award-type">
      <div className="fixture-awards-card__award-type__img">
        {profile?.profilePhoto && <Avatar media={profile.profilePhoto} />}
      </div>
      <div className="fixture-awards-card__award-type__desc">
        <div className="fixture-awards-card__award-type__desc__primary">
          {awardType.name.toUpperCase()}
        </div>

        {profile ? (
          <Link
            to={"/app/profile/" + profile.id}
            className="fixture-awards-card__award-type__desc__secondary"
          >
            {profile?.name}
          </Link>
        ) : (
          <div className="fixture-awards-card__award-type__desc__secondary">
            {"TBD"}
          </div>
        )}

        {profile && (
          <div className="fixture-awards-card__award-type__desc__tertiary">
            {profile?.handle && "@ " + profile.handle}
          </div>
        )}
      </div>
    </div>
  );
}

export default function EventAwards({ eventId, canManageEvent }) {
  const { loading, error, data } = useQuery(EVENT_AWARD_TYPES, {
    variables: {
      where: { event: { id: eventId }, subtype: "EVENT" },
      placementsWhere: { type: { name: "AWARD" } },
    },
  });

  if (error) {
    captureException({
      error,
      info: {
        type: "query",
        component: "EventAwards",
        query: "EVENT_AWARD_TYPES",
      },
    });
    console.log(error);
    return <div>error</div>;
  }

  if (loading || !data) {
    return <div />;
  }

  const awardTypes = data?.awardTypes;

  if (!awardTypes?.length) {
    return <div />;
  }

  const placementsCount = data?.awardTypes.reduce((accum, curr) => {
    return accum + (curr.placements?.length || 0);
  }, 0);

  // console.log(awardTypes);

  if (!placementsCount && !canManageEvent) {
    return <div />;
  }

  return (
    <Card className="fixture-awards-card">
      <div className="fixture-awards-card__title">Awards</div>
      {awardTypes?.map((at) => (
        <EventAwardType
          key={at.id}
          awardType={at}
          canManageEvent={canManageEvent}
        />
      ))}
    </Card>
  );
}
